import React from 'react';

const Plus = () => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.6518 16.8637H20.1518V6.36372C20.1518 5.88633 19.9622 5.42849 19.6246 5.09093C19.287 4.75336 18.8292 4.56372 18.3518 4.56372C17.8744 4.56372 17.4166 4.75336 17.079 5.09093C16.7414 5.42849 16.5518 5.88633 16.5518 6.36372V16.8637H6.0518C5.57441 16.8637 5.11657 17.0534 4.77901 17.3909C4.44144 17.7285 4.2518 18.1863 4.2518 18.6637C4.2518 19.1411 4.44144 19.5989 4.77901 19.9365C5.11657 20.2741 5.57441 20.4637 6.0518 20.4637H16.5518V30.9637C16.5518 31.4411 16.7414 31.8989 17.079 32.2365C17.4166 32.5741 17.8744 32.7637 18.3518 32.7637C18.8292 32.7637 19.287 32.5741 19.6246 32.2365C19.9622 31.8989 20.1518 31.4411 20.1518 30.9637V20.4637H30.6518C31.1292 20.4637 31.587 20.2741 31.9246 19.9365C32.2622 19.5989 32.4518 19.1411 32.4518 18.6637C32.4518 18.1863 32.2622 17.7285 31.9246 17.3909C31.587 17.0534 31.1292 16.8637 30.6518 16.8637Z"
        fill="#494949"
      />
    </svg>
  );
};

export default Plus;
